var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 128V0H96v128H0v256h96v128h320V384h96V128zM128 32h256v96H128zm256 448H128V320.1h256zm96-128h-64v-64H96v64H32V160h448z",
    fill: "#49555d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#42b3ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381 190.5h71.4v23.8H381zM166.7 345.3h166.7v23.8H166.7zM166.7 416.7H262v23.8h-95.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.5faf9797f8582b989624b7c9210433cc.svg";
export { ForwardRef as ReactComponent };